import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import SelectPeriod from '../../../Components/shared/SelectPeriod';
import SelectUser from '../../../Components/shared/SelectUser';
import { PeriodeDashboardListFtrCra } from '../../../data/Interfaces';
import { filtreListPeriodeMonthYear } from '../DashbordBackOffice';

function StatutFactures({allFactures,filtreClient,height,width,role}){

    StatutFactures.propTypes = {
        allFactures: PropTypes.any,
        filtreClient: PropTypes.any,
        height:PropTypes.any,
        width:PropTypes.any,
        role: PropTypes.any,
    };

    const [selectedPeriodFacture, setSelectedPeriodFacture] = useState('thisMonth'); // Default selected period
    const [customDateRangeFacture, setCustomDateRangeFacture] = useState({});
    const [selectedClientvalueFacture,setSelectedClientvalueFacture] = useState('all');// Default selected client
    const { i18n } = useTranslation();
    const [chartDataStatusFacture, setChartDataStatusFacture] = useState(
        {
            series: [],
            chart: {
                type: 'pie',
                height: 350,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            options:{
                labels:[],
                colors: ['#EFAF41', '#EC5B56','#165DFF'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                plotOptions: {
                    pie: {
                        startAngle: 0,
                        endAngle: 360,
                    }
                },
                stroke: {
                    show: true,
                    width: 0, // Set the stroke width to 0 to eliminate the gap between slices
                },
            },
        });

    const getStatusFactureCounts = (data) => {
        const counts = {
            paye: 0,
            nonPaye: 0,
            enCours: 0,
            total: data.length,
        };

        data.forEach((item) => {
            if (role === 'expert' || item.statutFacture !== 'groupe') {
                counts[item.statutPaiementCalculated]++;
            }
        });

        return counts;
    };

    useEffect(()=>{
        if(Array.isArray(allFactures) ){
            // Filter the 'allFactures' array to include only items where 'totalHtClient' is greater than 0 "exclude l'avoir"
            var filteredData = allFactures.filter(
                (item) => (item.totalHtClient > 0));

            filteredData=filtreListPeriodeMonthYear(allFactures,selectedPeriodFacture,customDateRangeFacture);

            if(filtreClient)
                if(selectedClientvalueFacture != 'all'){
                    filteredData = filteredData.filter(
                        (item) => item.companyDataId == selectedClientvalueFacture
                    );
                }

            let countsCra=getStatusFactureCounts(filteredData);

            setChartDataStatusFacture((prevState) => {
                return {
                    ...prevState,

                    series: Object.values(countsCra).slice(0, -1),
                    options:{
                        ...prevState.options,
                        labels:[i18n.t('Payé'),i18n.t('Impayé'),i18n.t('En attente de paiement')],
                        plotOptions: {
                            ...prevState.options.plotOptions,
                            pie: {
                                ...prevState.options.plotOptions.pie,
                                dataLabels: {
                                    ...prevState.options.plotOptions.pie.dataLabels,
                                    offset: -15, // Adjust the offset to vertically center the labels
                                    formatter: function (val, opts) {
                                        return opts.w.config.series[opts.seriesIndex];
                                    },
                                },
                            },
                        },

                    }
                };
            });
        }
    },[allFactures,customDateRangeFacture,selectedClientvalueFacture]);

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Statut factures')}</h1>
                <div className='filtre1'>
                    <div style={{width:'40%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriodFacture}
                            setSelectedPeriod={setSelectedPeriodFacture}
                            setCustomDateRange={setCustomDateRangeFacture}
                            listeVal={PeriodeDashboardListFtrCra}
                        />
                    </div>
                    {filtreClient &&
                        <div style={{width:'40%'}}>
                            <SelectUser
                                selectedClientvalue={selectedClientvalueFacture}
                                setSelectedClientvalue={setSelectedClientvalueFacture}
                            />
                        </div>
                    }
                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataStatusFacture.options}
                        series={chartDataStatusFacture.series}
                        type="pie"
                        width={'100%'}
                        height={'85%'}
                    />
                </div>
            </div>

        </>
    );
}
export default StatutFactures;
